import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Pagination,
  Container,
  Modal,
  Fade,
  IconButton,
  Link,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import { getUserEventsNews } from "../redux/actions/commonAction";
import Navbar from "../Components/Navbar";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import PageTitle from "../Components/PageTitle";
import NewsEventBanner from "../assets/News&Events.png";

const itemsPerPage = 4;

const NewsEvents = () => {
  const dispatch = useDispatch();
  const { userEventsNews, loading, error } = useSelector(
    (state) => state.userEventsNews
  );

  const [page, setPage] = useState(1);
  const [newsData, setNewsData] = useState(userEventsNews);
  const [openModal, setOpenModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleOpenModal = (item) => {
    setSelectedItem(item);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedItem(null);
  };

  useEffect(() => {
    dispatch(getUserEventsNews());
  }, [dispatch]);

  useEffect(() => {
    setNewsData(userEventsNews);
  }, [userEventsNews]);

  const paginatedData = newsData.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  return (
    <>
      <Navbar />
      <PageTitle
        title="Events & News - Shree Mangalam School"
        description="Stay updated with the latest news, announcements, and events at Shree Mangalam School. Discover academic milestones, celebrations, and student achievements."
        url="/news-events"
        keywords="school events, Shree Manglam news, RIMC announcements, Sainik school updates, student activities"
      />
      <Header image={NewsEventBanner} alt={"News & Events Banner"} />

      <Container sx={{ py: 4 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          News & Events
        </Typography>

        <Grid container spacing={2}>
          {paginatedData.map((item, index) => (
            <Grid item xs={12} key={index}>
              <Box elevation={0} sx={{ borderBottom: "1px solid #ddd", mt: 3 }}>
                <Box>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{
                      fontFamily: "Montserrat, sans-serif",
                      fontSize: "16px",
                      fontOpticalSizing: "auto",
                      fontStyle: "normal",
                      letterSpacing: 1,
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitLineClamp: 1,
                      WebkitBoxOrient: "vertical",
                    }}
                    dangerouslySetInnerHTML={{ __html: item.title }}
                  />

                  {/* Date */}
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{
                      mb: 1,
                      fontFamily: "Montserrat, sans-serif",
                      fontOpticalSizing: "auto",
                      fontStyle: "normal",
                      letterSpacing: 1,
                      color: "#AD1C86",
                      fontSize: "13px",
                    }}
                  >
                    {moment(item?.startDate).format("MMMM Do")},{" "}
                    {moment(item?.startDate).format("YYYY")} -{""}{" "}
                    {moment(item?.endDate).format("MMMM Do")},{" "}
                    {moment(item?.endDate).format("YYYY")}
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      mb: 1,
                      fontFamily: "Montserrat, sans-serif",
                      fontOpticalSizing: "auto",
                      fontStyle: "normal",
                      letterSpacing: 1,
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      fontSize: "15px",
                      lineHeight: 2,
                    }}
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />

                  {/* Read more */}
                  <Link
                    component="button"
                    underline="hover"
                    sx={{ color: "#cfa95f", fontSize: 13, mb: 1 }}
                    onClick={() => handleOpenModal(item)}
                  >
                    Read More →
                  </Link>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Box mt={3} display="flex" justifyContent="center">
          <Pagination
            count={Math.ceil(newsData.length / itemsPerPage)}
            page={page}
            onChange={handleChange}
            color="#065A79"
            sx={{
              "& .MuiPaginationItem-root": {
                color: "#065A79",
                fontFamily: "Montserrat, sans-serif",
                fontOpticalSizing: "auto",
                fontStyle: "normal",
                fontSize: "14px",
                letterSpacing: 1,
              },
              "& .Mui-selected": {
                backgroundColor: "#065A79 !important",
                color: "#fff !important",
              },
            }}
          />
        </Box>
      </Container>

      {/* Modal */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Fade in={openModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              p: 4,
              borderRadius: 2,
              width: { xs: "90%", md: 600 },
              maxHeight: "80vh",
              overflowY: "auto",
              position: "relative",
            }}
          >
            <IconButton
              onClick={handleCloseModal}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "#065A79",
              }}
            >
              <CloseIcon />
            </IconButton>

            <Typography
              variant="body1"
              sx={{
                mb: 1,
                fontWeight: "bold",
                fontFamily: "Montserrat, sans-serif",
                fontOpticalSizing: "auto",
                fontStyle: "normal",
                letterSpacing: 1,
                color: "#065A79",
              }}
            >
              News & Events
            </Typography>

            <hr />

            {selectedItem && (
              <>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 1,
                    mt: 3,
                    fontWeight: "bold",
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                    letterSpacing: 1,
                    // color: "#AD1C86",
                  }}
                  dangerouslySetInnerHTML={{ __html: selectedItem.title }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    mb: 2,
                    display: "block",
                    color: "#AD1C86",

                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                    letterSpacing: 1,
                    // fontSize: "13px",
                  }}
                >
                  {moment(selectedItem.startDate).format("MMMM Do")},{" "}
                  {moment(selectedItem.startDate).format("YYYY")} -{" "}
                  {moment(selectedItem.endDate).format("MMMM Do")},{" "}
                  {moment(selectedItem.endDate).format("YYYY")}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#333",
                    mt: 1,
                    fontFamily: "Montserrat, sans-serif",
                    fontSize: "15px",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                    letterSpacing: 1,
                    lineHeight: "1.8rem",
                  }}
                  dangerouslySetInnerHTML={{ __html: selectedItem.description }}
                />
              </>
            )}
          </Box>
        </Fade>
      </Modal>

      <Footer />
    </>
  );
};

export default NewsEvents;
